import { RegisterModule } from '@/typings/common'
import {
  PermissionsInfoModel as Data,
  PermissionsInfoModelCollection as Collection,
} from '@/typings/api/PermissionsInfoModel'
import { PermissionsInfoModelsApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import { MODULE_NAME } from './utils'


const useOptions = () => ({
  api: new Api(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as permissionsInfoModelsStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
